import { render, staticRenderFns } from "./flowPoolDetail.vue?vue&type=template&id=5df087b6&scoped=true&"
import script from "./flowPoolDetail.vue?vue&type=script&lang=js&"
export * from "./flowPoolDetail.vue?vue&type=script&lang=js&"
import style0 from "./flowPoolDetail.vue?vue&type=style&index=0&id=5df087b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df087b6",
  null
  
)

export default component.exports